import React, {useState, useEffect} from 'react'
import { Form, Skeleton, Input, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useFetch } from './Hooks/useFetch';
import { CloseCircleTwoTone, CheckCircleTwoTone, LockOutlined } from '@ant-design/icons'
const { Text } = Typography; 

export default function PasswordField ({
    setPasswordPolicyTracker:propsSetPasswordPolicyTracker,
    validatePassword:propsValidatePassword,
    isLoading:propsIsLoading,
    size:propsSize,
    label:propsLabel,
    input:propsInput,
    isRequired:propsIsRequired,
    isRequiredText:propsIsRequiredText
}) {  

    const { t } = useTranslation(['login'])
    const [doFetch] = useFetch()

    const [containsCapital, setContainsCapital] = useState(false)
    const [containsNumber, setContainsNumber] = useState(false)
    const [containsSpecialCharacter, setContainsSpecialCharacter] = useState(false)
    const [containsMinimumCharacters, setContainsMinimumCharacters] = useState(false)
    const [isBannedPassword, setIsBannedPassword] = useState(false)
    const [isChanged, setIsChanged] = useState(false)

    const [passwordPolicies, setPasswordPolicies] = useState({})
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        if(propsSetPasswordPolicyTracker) {
            doFetch("/Configuration/passwordpolicies")
            .then((response) => {
                setPasswordPolicies(response.result);
                setIsLoading(false);
            })
            //TODO what if no policies found
        }

        setIsLoading(false);

    }, // eslint-disable-next-line 
    [])

    useEffect(() => {
        if(isChanged)
        {
            propsValidatePassword(containsCapital && !isBannedPassword && containsNumber && containsSpecialCharacter && containsMinimumCharacters)
        }
        setIsChanged(false)
    }, // eslint-disable-next-line 
    [containsCapital, isBannedPassword, containsNumber, containsSpecialCharacter, containsMinimumCharacters])

    if (propsIsLoading || isLoading) {
        return <Skeleton.Input style={{marginBottom:"16px"}} active="false" size={propsSize} />
    }

    if(propsSetPasswordPolicyTracker)
    {
        const descriptionElement = (
            <>
                {containsMinimumCharacters 
                    ? <CheckCircleTwoTone twoToneColor='green' /> 
                    : <CloseCircleTwoTone twoToneColor='red'/> } 
                <Text>{` ${t("resetPassword.requiredNonCapital.before")} ${passwordPolicies.minimumLenght} ${t("resetPassword.requiredNonCapital.middle")} ${passwordPolicies.maximumLength} ${t("resetPassword.requiredNonCapital.after")}`}</Text>

                {passwordPolicies.capitalCountLenght > 0 &&
                    <>
                        <br />
                        {containsCapital 
                            ? <CheckCircleTwoTone twoToneColor='green' /> 
                            : <CloseCircleTwoTone twoToneColor='red'/> } 
                            <Text>{` ${t("resetPassword.requiredCapital.before")} ${passwordPolicies.capitalCountLenght} ${t("resetPassword.requiredCapital.after")}`}</Text>
                    </>
                }
                {passwordPolicies.numberCountLenght > 0 &&
                    <>
                        <br />
                        {containsNumber 
                            ? <CheckCircleTwoTone twoToneColor='green' /> 
                            : <CloseCircleTwoTone twoToneColor='red'/> } 
                            <Text>{` ${t("resetPassword.requiredNumber.before")} ${passwordPolicies.numberCountLenght} ${t("resetPassword.requiredNumber.after")}`}</Text>
                    </>
                }
                {passwordPolicies.specialCountLenght > 0 &&
                    <>
                        <br />
                        {containsSpecialCharacter 
                            ? <CheckCircleTwoTone twoToneColor='green' /> 
                            : <CloseCircleTwoTone twoToneColor='red'/> } 
                        <Text>{` ${t("resetPassword.requiredSpecialSign.before")} ${passwordPolicies.specialCountLenght} ${t("resetPassword.requiredSpecialSign.after")}`}</Text>
                    </>
                }
                {passwordPolicies.enableBannedPassword &&
                    <>
                        <br />
                        {!isBannedPassword 
                            ? null
                            : <>
                            <CloseCircleTwoTone twoToneColor='red'/>  
                            <Text>{` ${t("resetPassword.requiredNotBanned")}`}</Text>
                            </>
                            }
                    </>
                }
            </>
        )
        return(
            <div>
                {passwordField()}
                {descriptionElement}
            </div>
        )
    }

    return passwordField()

    function passwordField()
    {
        return (
            <Form.Item style={{marginBottom:"8px"}}
            label={propsLabel}
            name={propsInput}
            rules={[{ required: propsIsRequired, message: propsIsRequiredText }]}>          
            <Input.Password 
                name={propsInput} 
                onChange={onChange}
                prefix={<LockOutlined />}
            />
            </Form.Item>
        )
    }

    function onChange(event)
    {
        event.preventDefault()
        if(propsSetPasswordPolicyTracker)
        {
            const text = event.target.value
            const splittedText = text.split('')

            let ammountSpecialFound = 0;
            let ammountCapitalFound = 0;
            let ammountNumberFound = 0;
            splittedText.forEach(t => {
                if(passwordPolicies.allowedSpecialCharacters.includes(t)) {
                    ammountSpecialFound++;
                }

                if(t.match(/[A-Z]/)) {
                    ammountCapitalFound++;
                }

                if(t.match(/\d+/)) {
                    ammountNumberFound++;
                }
            })

            ammountSpecialFound >= passwordPolicies.specialCountLenght 
                                    ? setContainsSpecialCharacter(true) 
                                    : setContainsSpecialCharacter(false);
            ammountCapitalFound >= passwordPolicies.capitalCountLenght 
                                    ? setContainsCapital(true) 
                                    : setContainsCapital(false);
            ammountNumberFound >= passwordPolicies.numberCountLenght 
                                    ? setContainsNumber(true) : setContainsNumber(false)
            text.length >= passwordPolicies.minimumLenght && text.length <= passwordPolicies.maximumLength
                            ? setContainsMinimumCharacters(true) 
                            : setContainsMinimumCharacters(false)

            setIsBannedPassword(false);
            if(passwordPolicies.enableBannedPassword) {
                passwordPolicies.bannedPasswords.forEach(bPassword => {
                    if(text.toLowerCase().includes(bPassword.toLowerCase())) {
                        setIsBannedPassword(true);
                    }
                })
            }

            setIsChanged(true)
        }
    }

}